import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h4", { class: "px-4 lg:px-0 mb-2" }, "Transactions", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalTable = _resolveComponent("BalTable")
  const _component_BalCard = _resolveComponent("BalCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_BalCard, {
      shadow: "lg",
      class: "mt-4",
      square: _ctx.upToLargeBreakpoint,
      noBorder: _ctx.upToLargeBreakpoint,
      noPad: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BalTable, {
          columns: _ctx.columns,
          data: _ctx.data,
          "is-loading": _ctx.isLoading,
          "skeleton-class": "h-64",
          sticky: "both",
          square: _ctx.upToLargeBreakpoint,
          onLoadMore: _ctx.loadMoreSwaps,
          isSortable: false,
          "is-paginated": _ctx.hasNextPage,
          isLoadingMore: _ctx.isLoadingMore
        }, null, 8, ["columns", "data", "is-loading", "square", "onLoadMore", "is-paginated", "isLoadingMore"])
      ]),
      _: 1
    }, 8, ["square", "noBorder"])
  ], 64))
}